import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useArenaItemMixins } from '@/modules/arena/item/model/mixins';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { arenaService } from '@/services/arena';
import useVuelidate from '@vuelidate/core';
import { onMounted } from 'vue';

export function useArenaItemClone() {
    const router = useAppRouter();

    const { fetchAllMatches, gameMatchOptions } = useGameMatchList();
    const { model, creationValidator, fetch } = useArenaItemMixins();
    const v$ = useVuelidate(creationValidator, model);

    const actions = {
        clone: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () =>
                arenaService.item.create(
                    model.id,
                    model.name,
                    model.matchId,
                    model.maxRejection,
                    model.price,
                    model.jackpotInit,
                    model.jackpotWinPercent,
                    model.jackpotDonation,
                    model.prizes,
                    model.ticketType,
                    model.timeUnit,
                    model.timeDuration,
                    model.publishSeconds,
                    model.startSeconds,
                    model.closeSeconds,
                    model.endSeconds,
                    model.publishTime.getTime(),
                    model.unpublishTime?.getTime() || null
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_ARENA.ITEM.INDEX })
        })
    };

    onMounted(async () => {
        await fetchAllMatches();
        await fetch();
    });

    return { model, v$, gameMatchOptions, actions };
}
